import { initializeSdk } from '@eventbrite/statsig';
import { AppProps } from './types';

export const LISTING_PAGE_EXPERIMENTS_LAYER = 'listing_page_experiments';

export const initializeStatsigSdk = async (app: AppProps) => {
    const isRepeatingEvent =
        app.event?.isSeriesParent && !!app.event?.childEvents;
    await initializeSdk({
        user: {
            userID: app.user.publicId,
            custom: {
                eventId: app.event?.id,
                organizerId: app.organizer?.id,
                ebDomain: app.env?.ebDomain,
                shouldShowCompactCheckout: app.event?.shouldShowCompactCheckout,
                isRepeatingEvent: isRepeatingEvent,
                onlineEvent: app.event?.isOnlineEvent,
                isSeriesParent: app.event?.isSeriesParent,
                isSeries: !!app.event?.childEvents?.length,
                listed: app.event?.isListed,
                isLive: app.event?.isLive,
                protected: app.event?.isProtected,
                isFree: !app.components.eventDetails.refund.isPaidEvent,
                isPaid: app.components.eventDetails.refund.isPaidEvent,
                isDonation: app.event?.hasDonationTicketsAvailable,
                salesStatus: app.event?.salesStatus.sales_status,
                isExternalTicketAvailable:
                    app.components?.conversionBar.externalTicketsAreAvailable,
                hasDiscountCode:
                    app.event?.compactCheckoutDisqualifications.discount_code,
                hasAddons:
                    app.event?.compactCheckoutDisqualifications.has_addons,
                hasDiscount:
                    app.event?.compactCheckoutDisqualifications.has_discounts,
                hasWaitingRoom:
                    app.event?.compactCheckoutDisqualifications
                        .has_not_waiting_room ??
                    app.event?.compactCheckoutDisqualifications
                        .has_waiting_room,
                hasWaitlist:
                    app.event?.compactCheckoutDisqualifications.has_waitlist,
                isCanceled:
                    app.event?.compactCheckoutDisqualifications.is_canceled,
                isPostponed:
                    app.event?.compactCheckoutDisqualifications.is_postponed,
                isRSVP: app.event?.compactCheckoutDisqualifications.is_rsvp,
                isSalesEnded:
                    app.event?.compactCheckoutDisqualifications.is_sales_ended,
                hasMoreThanOneTicket:
                    app.event?.compactCheckoutDisqualifications
                        .more_than_one_ticket,
                totalTicketsCount: app.event?.ticketsInfo.totalTicketsCount,
                isReservedSeating:
                    app.event?.compactCheckoutDisqualifications
                        .reserved_seating,
                isSoldOut: app.event?.compactCheckoutDisqualifications.sold_out,
                repeatingEvent:
                    app.event?.compactCheckoutDisqualifications.repeating_event,
                hasDonatios:
                    app.event?.compactCheckoutDisqualifications.has_donations,
                venueCountry: app.event?.venue?.country,
                venueRegion:
                    app.event?.venue?.region !== ''
                        ? app.event?.venue?.region
                        : undefined,
                timeZone: app.event?.start?.timezone,
            },
        },
    });
};
